import React, { Fragment, useEffect, useState, useContext } from "react";
import "../HomePage/HomePage.css";
import { Container } from "react-bootstrap";
import DialyFlashSale from "./DialyFlashSale";
import Categories from "./Categories";
import DealOfDay from "./DealOfDay";
import MyAccount from "./MyAccount";
import { getScreen } from "../../Actions/Screens";
import { usersData, BannerData, userStatus } from "../../App";
import {
  app_message_widget,
  app_section_widget,
  category_widget,
} from "../../Actions/Widgets";
import AcceptCreditAgreementModal from "../Modals/AcceptCreditAgreementModal";
import { creditOnboardingPopup } from "../../Actions/ApplyCredit";
import CommonWidget from "./CommonWidget";
import LandingBanner from "../Modals/LandingBanner";
import { GamificationBanner } from "./GamificationBanner";
import BannerWidget from "./BannerWidget";
import { getOnboardingData } from "../../Actions/Onboarding";

const SaveoHome = ({ getCatgories }) => {
  const [widgets, setWidgets] = useState([]);
  const [renderStatus, setRenderStatus] = useState([]);
  const [appMessageRes, setAppMessageRes] = useState(null);
  const [appSectionRes, setAppSectionRes] = useState(null);
  const [categoryRes, setCategoryRes] = useState(null);
  const [shimmerHomePage, setShimmerHomepage] = useState(false);
  const [shimmerCategories, setShimmerCategories] = useState(false);
  const [shimmerMyAccount, setShimmerMyAccount] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const { userData, setUserData, setErrorHandler } = useContext(usersData);
  const { setUserLoggedIn, setIsUserEnabled } = useContext(userStatus);
  const { setBannerData } = useContext(BannerData);
  const [agreementPopUpData, setAgreementPopUpData] = useState({});
  const [agreementPopUp, setAgreementPopUp] = useState({ show: false });
  const [upadateWidgets, setUpadateWidgets] = useState(false);
  const [renderWidgetData, setRenderWidgetData] = useState();
  const [landingModal, setLandingModal] = useState({ show: false, content: "" });

  const getCreditUserOnboardingPopUp = () => {
    let data = localStorage.getItem("userData");
    data = JSON.parse(data);
    let params = { retailerId: data?.id, source: "home_screen" };
    creditOnboardingPopup(params, {})
      .then((res) => {
        setAgreementPopUpData(res?.data?.data);
        if (res?.data?.data?.showPopUp) setAgreementPopUp({ show: true });
      })
      .catch(() => {});
  };

  const loadHomeScreen = () => {
    let storedUserData = localStorage.getItem("userData");
    if (!storedUserData) return;

    getCreditUserOnboardingPopUp();
    const params = {
      retailerId: JSON.parse(storedUserData).id,
      screenName: "home_screen",
    };
    setShimmerHomepage(true);
    let home_screen = () =>
      getScreen("HOME_SCREEN", params, {})
        .then((res) => {
          setShimmerHomepage(false);
          setWidgets(res.data.data);
        })
        .catch((error) => {
          setErrorHandler({
            show: true,
            screen: "home_screen",
            errorList: [{ error: error, code: "" }],
            fn: function () {
              home_screen();
            },
          });
        });
    home_screen();
  };

  const initAuthFromHash = () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get("accessToken");
    const refreshTokenVal = params.get("refreshToken");

    if (accessToken && refreshTokenVal) {
      const userAuth = {
        data: { jwtToken: accessToken, refreshToken: refreshTokenVal, isPasswordSet: true },
      };
      localStorage.setItem("userAuth", JSON.stringify(userAuth));
      localStorage.removeItem("userData");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.setItem("currentScreen", "home_screen");
    localStorage.removeItem("currentScreenBannerData");

    initAuthFromHash();

    getOnboardingData("getUserData", {})
      .then((res) => {
        const user = res.data.data;
        localStorage.setItem("userData", JSON.stringify(user));
        setUserData(user);
        setIsUserEnabled(user);
        setUserLoggedIn(true);
        setAuthLoading(false);
        loadHomeScreen();
      })
      .catch(() => {
        setAuthLoading(false);
      });

    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      if (params.get("accessToken") && params.get("refreshToken")) {
        initAuthFromHash();
        setAuthLoading(true);
        setUserLoggedIn(false);
        getOnboardingData("getUserData", {})
          .then((res) => {
            const user = res.data.data;
            localStorage.setItem("userData", JSON.stringify(user));
            setUserData(user);
            setIsUserEnabled(user);
            setUserLoggedIn(true);
            setAuthLoading(false);
            loadHomeScreen();
          })
          .catch(() => {
            setAuthLoading(false);
          });
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  useEffect(() => {
    let timeRecord = localStorage.getItem("UPIBanner");
    if (!timeRecord) {
      setLandingModal({ show: true, content: "" });
      localStorage.setItem("UPIBanner", new Date().getTime());
    } else {
      let currDate = new Date().getTime();
      if (currDate - timeRecord > 86400000) {
        setLandingModal({ show: true, content: "" });
        localStorage.setItem("UPIBanner", currDate);
      }
    }
  }, []);

  const getWidgetsData = () => {
    let storedUserData = localStorage.getItem("userData");
    let errorList = [];
    if (widgets && widgets.length > 0 && storedUserData) {
      let promises = widgets.map((widget, index) => {
        if (widget.widgetName === "app_message_widget" && !appMessageRes) {
          let obj = app_message_widget(widget.data.apiEndPoint);
          obj
            .then((res) => {
              setAppMessageRes(res.data);
              renderWidget(widget, index, false, null);
            })
            .catch((error) => {
              errorList.push(obj);
              renderWidget(widget, index, true, error);
            });
          return obj;
        } else if (widget.widgetName === "app_section_widget" && !appSectionRes) {
          let obj;
          setShimmerCategories(true);
          obj = app_section_widget(widget.data.apiEndPoint);
          obj
            .then((res) => {
              setAppSectionRes(res.data.data.appSectionList);
              if (getCatgories) getCatgories(res.data.data.appSectionList);
              setShimmerCategories(false);
              renderWidget(widget, index, false, null);
            })
            .catch((error) => {
              errorList.push(obj);
              renderWidget(widget, index, true, error);
            });
          return obj;
        } else if (widget.widgetName === "category_widget" && !categoryRes) {
          let obj;
          setShimmerMyAccount(true);
          obj = category_widget(
            widget.data.apiEndPoint,
            JSON.parse(localStorage.getItem("userData")).id
          );
          obj
            .then((res) => {
              setCategoryRes(res.data);
              setShimmerMyAccount(false);
              renderWidget(widget, index, false, null);
            })
            .catch((error) => {
              errorList.push(obj);
              renderWidget(widget, index, true, error);
            });
          return obj;
        }
      });

      Promise.all(promises)
        .then(() => {})
        .catch(() => {});
    }
  };

  const renderWidget = (widget, widgetIndex, errorStatus, error) => {
    setRenderWidgetData({ widget, widgetIndex, errorStatus, error });
  };

  useEffect(() => {
    if (widgets?.length) {
      let arr = [...renderStatus];
      arr.push(renderWidgetData);
      setRenderStatus(arr);
    }
  }, [renderWidgetData]);

  const reRenderWidgets = () => {
    let widgetsData = widgets;
    let arr = [...renderStatus];
    let sliceIndexes = [];
    renderStatus.forEach((data, i) => {
      if (data?.errorStatus) {
        widgetsData[data.widgetIndex].renderStatus =
          !widgetsData[data.widgetIndex].renderStatus;
        sliceIndexes.push(i);
      } else {
        delete widgetsData[data.widgetIndex].renderStatus;
      }
    });
    arr = arr.filter((data, i) => !sliceIndexes.includes(i));
    setRenderStatus(arr);
    setWidgets(widgetsData);
    setUpadateWidgets(!upadateWidgets);
  };

  useEffect(() => {
    getWidgetsData();
  }, [widgets, upadateWidgets]);

  useEffect(() => {
    if (renderStatus.length === widgets.length - 1) {
      let errorList = [];
      let errorState = false;
      for (let i = 0; i < renderStatus.length; i++) {
        if (renderStatus[i].errorStatus) {
          errorState = true;
          errorList.push({
            error: renderStatus[i].error,
            code: renderStatus[i]?.widget?.data?.apiIdentifier,
          });
        }
      }
      if (errorState) {
        setErrorHandler({
          show: true,
          screen: "home_screen",
          error: "",
          errorList: errorList,
          fn: function () {
            reRenderWidgets();
          },
        });
      }
    }
  }, [renderStatus]);

  if (authLoading) {
    return (
      <div className="homepage">
        {[...Array(5)].map((_, index) => (
          <Container key={index}>
            <div className="skeletal_div animateShimmer"></div>
          </Container>
        ))}
      </div>
    );
  }

  return (
    <Fragment>
      <LandingBanner
        show={landingModal.show && userData?.onlinePaymentEnabled}
        onHide={() => setLandingModal({ show: false, content: "" })}
      />
      <AcceptCreditAgreementModal
        show={agreementPopUp.show}
        creditUserData={agreementPopUpData}
        onHide={() => setAgreementPopUp({ show: false })}
      />
      {shimmerHomePage ? (
        <div className="homepage">
          {[...Array(5)].map((_, index) => (
            <Container key={index}>
              <div className="skeletal_div animateShimmer"></div>
            </Container>
          ))}
        </div>
      ) : userData ? (
        <div className={"homepage"}>
          {widgets &&
            widgets.map((widget, index) => {
              return widget.widgetName === "app_message_widget" ? (
                <></>
              ) : (
                <Fragment key={index}>
                  {widget.widgetName === "banner_widget" && (
                    <BannerWidget
                      renderWidget={renderWidget}
                      widgetIndex={index}
                      widgetData={widget}
                    />
                  )}
                  {widget.widgetName === "gamification_banner_widget" && (
                    <GamificationBanner />
                  )}
                  {widget.widgetName === "timer_product_widget" && (
                    <DialyFlashSale
                      widgetIndex={index}
                      renderWidget={renderWidget}
                      widgetData={widget}
                    />
                  )}
                  {widget.widgetName === "timer_product_widget_two" && (
                    <DealOfDay
                      widgetIndex={index}
                      renderWidget={renderWidget}
                      widgetData={widget}
                    />
                  )}
                  {!shimmerCategories &&
                    widget.widgetName === "app_section_widget" &&
                    appSectionRes &&
                    appSectionRes.length > 0 && (
                      <Categories appSectionRes={appSectionRes} />
                    )}
                  {shimmerCategories &&
                    widget.widgetName === "app_section_widget" && (
                      <Categories shimmer={shimmerCategories} />
                    )}
                  {widget.widgetName === "product_list_widget" && (
                    <CommonWidget
                      renderWidget={renderWidget}
                      widgetIndex={index}
                      widgetData={widget}
                    />
                  )}
                  {widget.widgetName === "category_widget" &&
                    categoryRes &&
                    categoryRes.length !== 0 && (
                      <MyAccount categoryRes={categoryRes} />
                    )}
                </Fragment>
              );
            })}
        </div>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default SaveoHome;
